import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { useNameColumn } from 'components/CIMSTable/common/hooks/useNameColumn'
import { HelpMessage } from 'utils/constants'
import { ReportFilename } from '../../ReportFilenamesContext/types'
import Example from './components/Example'
import Template from './components/Template'

export function useColumns(): CIMSColumn<ReportFilename>[] {
  const help = HelpMessage.Exports
  return [
    useNameColumn({
      help: help.Name('report'),
      sort: { default: 'ascend' },
      width: 268,
    }),
    {
      title: 'Example',
      help: help.Example,
      render: (record) => <Example {...record} />,
      width: 500,
    },
    {
      title: 'Template',
      help: help.Template('report'),
      render: (record) => <Template {...record} />,
      width: 500,
    },
  ]
}
